import { LexerMatcherLibrary } from "../../text/lexer/LexerMatcherLibrary";
import { SourceInfo, SourceRange } from "../../text/lexer/parsing/SourceInfo";
import { BinaryExpression } from "../expressions/BinaryExpression";
import { FunctionExpression } from "../expressions/FunctionExpression";
import { GroupExpression } from "../expressions/GroupExpression";
import { RJExpressionNode } from "../expressions/RJExpressionNode";
import { RJExpressionNodeType } from "../expressions/RJExpressionNodeType";
import { RJToken } from "../expressions/RJToken";
import { VariableExpression } from "../expressions/VariableExpression";
import { RJParserMessages } from "../parsers/RJParserMessages";
import { RJLexer } from "../RJLexer";
import { RJParser } from "../RJParser";
import { Operator } from "./Operator";

export class VariableOperator extends Operator
{
  constructor( parser:RJParser )
  {
    super( parser );
    this.setStartToken( RJLexer.WordMatcher.type, null );    
  }

  processStartNode( nodes:RJExpressionNode[], index:number ):boolean
  {    
    let name = nodes[ index ] as RJToken;

    let variableExpression = new VariableExpression( this._parser, name.sourceRange );
    variableExpression.setVariable( name );

    RJExpressionNode.replaceRange( nodes, index, 1, variableExpression );

    return true;
  }
}
